module.exports = __webpack_public_path__ + "b837372d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/mobile/components/Modal/cross.svg
// module id = 1399
// module chunks = 0 2 3 4 15 17 18 19 22 25 28 29 30 31 34 35 36 37 40